// Section 22 Jobs tab root: reads the store (game, draft, projection, selection) and renders the
// auto-fill control and the board.
import {
  applyAutoFill,
  assignJob,
  discardAutoFill,
  draft,
  game,
  hoverPerson,
  projection,
  proposeAutoFill,
  runConfig,
  selectPerson,
  status,
  ui,
} from '../../store';
import { autoFillVM, jobsVM } from '../../viewModels';
import { AutoFill } from './auto-fill';
import { JobsBoard } from './jobs-board';
import './jobs.css';

export function JobsTab() {
  const g = game.value;
  if (g === null) return null;
  const d = draft.value;
  const u = ui.value;
  const p = projection.value;
  const canEdit = status.value === 'deciding';
  const proposal = u.autoFill?.turn === g.turn ? u.autoFill.assignments : null;
  return (
    <div class="jobs-tab">
      <AutoFill
        rows={autoFillVM(g, d, proposal)}
        open={proposal !== null}
        canEdit={canEdit}
        onPropose={() => proposeAutoFill()}
        onApply={() => applyAutoFill()}
        onDiscard={discardAutoFill}
      />
      <JobsBoard
        vm={jobsVM(g, d, p.result, p.baseline, p.pending, u.selectedPersonId, runConfig())}
        hovered={u.hoveredPersonId}
        canEdit={canEdit}
        onSelect={selectPerson}
        onAssign={(id, job) => {
          assignJob(id, job);
          selectPerson(null);
        }}
        onHover={hoverPerson}
      />
    </div>
  );
}
